module.exports = __webpack_public_path__ + "static/media/bg_ancestry_chart.b4072e14.png";